<template>
  <div style="background: white">
    <Header
      :show="true"
      title="出库领用申请"
      left="prepage"
      :click-left="clickLeft"
    />
    <div style="padding-bottom: 8vh">
      <!-- 顶部搜索相关 Cell -->
      <div>
        <van-cell
          title="审核状态"
          is-link
          :value="statusName"
          @click="visibleStatusCheck = true"
        />
        <van-action-sheet
          v-model="visibleStatusCheck"
          :actions="statusList"
          cancel-text="取消"
          description="请选择查询的审核状态"
          @select="onStatusChoose"
        />
        <div style="padding: 12px">
          <van-button
            round
            block
            type="info"
            @click="getOutStockList"
          >
            查询
          </van-button>
          <van-button
            round
            block
            type="primary"
            style="margin-top: 10px"
            @click="handleClickEdit()"
          >
            创建申请
          </van-button>
        </div>
      </div>
      <el-table
        ref="table"
        v-loading="loading"
        size="small"
        :data="receiptApplyList"
        style="width: 100%"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30"
        >
          <template slot-scope="{ row }">
            <el-form
              label-width="80px"
              :show-message="false"
            >
              <el-form-item label="申领物品">
                <el-tag
                  v-for="item in row.stockDetailList"
                  :key="item.id"
                  size="small"
                  type="info"
                  style="margin-right: 6px"
                >
                  {{ item.materialsName }}
                </el-tag>
              </el-form-item>
              <el-form-item label="申请日期">
                {{ row.createTime | formatDate }}
              </el-form-item>
              <el-form-item label="备注">
                {{ row.remark }}
              </el-form-item>
              <el-form-item label="操作">
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleClickDetail(row)"
                >
                  查看明细
                </el-button>
                <el-button
                  size="mini"
                  :disabled="row.applyStatus != 0"
                  type="primary"
                  @click="handleClickApply(row)"
                >
                  审核
                </el-button>
                <el-button
                  size="mini"
                  :disabled="row.applyStatus != 0"
                  type="primary"
                  @click="handleClickEdit(row)"
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  :disabled="row.applyStatus != 0"
                  @click="handleClickDelete(row)"
                >
                  删除
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="60"
        />
        <el-table-column
          label="单号"
          prop="sn"
          show-overflow-tooltip
        />
        <el-table-column
          label="申请人"
          prop="name"
          width="80"
        />
        <el-table-column
          label="状态"
          prop="status"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.applyStatus === '0'"
              size="small"
              type="info"
            >
              待审核
            </el-tag>
            <el-tag
              v-if="row.applyStatus === '1'"
              size="small"
              type="success"
            >
              已审核
            </el-tag>
            <el-tag
              v-if="row.applyStatus === '-1'"
              size="small"
              type="danger"
            >
              已拒绝
            </el-tag>
            <el-tag
              v-if="row.applyStatus === '2'"
              size="small"
              type="warning"
            >
              部分领用
            </el-tag>
            <el-tag
              v-if="row.applyStatus === '3'"
              size="small"
              type="primary"
            >
              全部领用
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="tableTotal > 0"
        :total="tableTotal"
        background
        layout="prev, pager, next"
        :current-page.sync="params.page"
        :limit.sync="params.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="getOutStockList"
      />
    </div>
    <van-popup
      v-model="visibleApply"
      position="bottom"
    >
      <div style="background-color: white">
        <div style="font-size: 16px; text-align: center; padding: 12px">
          审核单据
        </div>
        <div>
          <van-field
            name="status"
            label="审核状态"
          >
            <template #input>
              <van-radio-group
                v-model="applyValue.status"
                direction="horizontal"
              >
                <van-radio name="1">
                  通过
                </van-radio>
                <van-radio name="-1">
                  拒绝
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="applyValue.remark"
            clear-trigger="always"
            name="remark"
            label="审核备注"
            placeholder="可选"
          />
        </div>
        <div style="margin-top: 100px; padding: 12px">
          <van-button
            block
            type="info"
            @click="handleAudit"
          >
            提交审核
          </van-button>
        </div>
      </div>
    </van-popup>
    <Footer value="service" />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import { getList, del, audit } from "@/api/wms/outStock";
import { Dialog } from "vant";

import dayjs from "dayjs";

import { mapGetters } from "vuex";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

const initApplyValue = {
  status: "1",
  remark: "",
};
export default {
  components: { Header, Footer },
  filters: {
    formatDate(value) {
      if (!value) return value;
      return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  data: () => ({
    params: { status: "", page: 1, limit: 10 },
    visibleStatusCheck: false,
    statusList: [
      { name: "全部", value: "" },
      { name: "待审核", value: 0 },
      { name: "已拒绝", value: -1 },
      { name: "已审核", value: 1 },
      { name: "部分领用", value: 2 },
      { name: "全部领用", value: 3 },
    ],
    loading: false,
    receiptApplyList: [],
    visibleApply: false,
    applyValue: { ...initApplyValue },
    tableTotal: 0,
  }),
  computed: {
    ...mapGetters({
      userid: "user/userid",
    }),
    statusName() {
      return (
        this.statusList.find((item) => item.value === this.params.status)
          ?.name ?? ""
      );
    },
  },
  created() {
    this.getOutStockList();
  },
  methods: {
    checkPermission,
    clickLeft() {
      this.$router.go(-1);
    },
    handleTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickEdit(row) {
      this.$router.push({
        path: "/service/business/item-receipt/create",
        query: row,
      });
    },
    handleClickApply(row) {
      this.applyValue.id = row.id;
      this.visibleApply = true;
    },
    handleClickDetail(row) {
      this.$router.push({
        path: "/service/business/item-receipt/detail",
        query: row,
      });
    },
    async handleAudit() {
      const payload = {
        ...this.applyValue,
      };
      const { data } = await audit(payload);
      if (data.code === 2000) {
        this.$toast.success({ message: "审核操作处理成功" });
        this.applyValue = { ...initApplyValue };
        this.visibleApply = false;
        this.getOutStockList()
      }
    },
    async handleClickDelete(row) {
      await Dialog({
        title: "删除出库单",
        message: "是否确认删除此出库单",
        showCancelButton: true,
      });
      const { data } = await del(row.id);
      if (data.code === 2000) {
        this.$toast.success({ message: "操作成功" });
        this.receiptApplyList = this.receiptApplyList.filter(
          (item) => item !== row
        );
      }
    },
    onStatusChoose(value) {
      this.params.status = value.value;
      this.visibleStatusCheck = false;
    },
    async getOutStockList() {
      const param = {
        page: { current: this.params.page, size: this.params.limit },
        where: {
          "eq_wos.applyStatus": this.params.status || undefined,
          "desc_wos.create_time": 1,
        },
      };
      this.loading = true;
      const { data } = await getList(param).finally(() => {
        this.loading = false;
      });
      if (data.code === 2000) {
        const result = data.data;
        this.receiptApplyList = result.records;
        this.tableTotal = result.total;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form {
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>